import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const MainMenu = () => {
  const { t, i18n } = useTranslation('translation')

  useEffect(() => {
    const trigger = document.querySelector('.zn-res-trigger')
    const sourceMenu = document.querySelector('#main-menu > ul')

    if (!trigger || !sourceMenu) {
      return undefined
    }

    document.querySelector('#zn-res-menu')?.remove()
    document.querySelector('.zn-res-menu-overlay')?.remove()

    const responsiveMenu = sourceMenu.cloneNode(true)
    responsiveMenu.id = 'zn-res-menu'
    responsiveMenu.className = ''

    const overlay = document.createElement('div')
    overlay.className = 'zn-res-menu-overlay'

    const openSubmenu = (submenu, event) => {
      event.preventDefault()
      submenu.classList.add('zn-menu-visible')
    }

    const closeMenu = () => {
      responsiveMenu.classList.remove('zn-menu-visible')
      responsiveMenu.querySelectorAll('.zn-menu-visible').forEach((menu) => {
        menu.classList.remove('zn-menu-visible')
      })
      document.body.classList.remove('zn_res_menu_visible')
    }

    const createBackItem = () => {
      const backItem = document.createElement('li')
      backItem.className = 'zn_res_menu_go_back'
      backItem.innerHTML =
        '<span class="zn_res_back_icon fas fa-chevron-left"></span><a href="#">Back</a><a href="#" class="zn-close-menu-button"><span class="fas fa-times"></span></a>'
      backItem.addEventListener('click', (event) => {
        event.preventDefault()
        const activeMenu = backItem.closest('.zn-menu-visible')

        if (activeMenu === responsiveMenu) {
          closeMenu()
          return
        }

        activeMenu?.classList.remove('zn-menu-visible')
      })
      return backItem
    }

    responsiveMenu.querySelectorAll('li').forEach((item) => {
      const submenu = Array.from(item.children).find((child) => child.tagName === 'UL')

      if (!submenu) {
        return
      }

      item.classList.add('zn_res_has_submenu')

      const submenuTrigger = document.createElement('span')
      submenuTrigger.className = 'zn_res_submenu_trigger glyphicon glyphicon-chevron-right'
      submenuTrigger.addEventListener('click', (event) => openSubmenu(submenu, event))

      const submenuLink = Array.from(item.children).find((child) => child.tagName === 'A')
      submenuLink?.addEventListener('click', (event) => openSubmenu(submenu, event))

      item.prepend(submenuTrigger)
      submenu.prepend(createBackItem())
    })

    responsiveMenu.prepend(createBackItem())
    document.body.append(responsiveMenu, overlay)

    const openMenu = (event) => {
      event.preventDefault()
      document.body.classList.add('zn_res_menu_visible')
      responsiveMenu.classList.add('zn-menu-visible')
    }

    const handleMenuClick = (event) => {
      if (event.target.closest('.zn_res_menu_go_back')) {
        return
      }

      if (event.target.closest('.zn_res_has_submenu > a')) {
        return
      }

      const link = event.target.closest('a')

      if (link && !link.classList.contains('zn-close-menu-button')) {
        closeMenu()
      }
    }

    trigger.addEventListener('click', openMenu)
    overlay.addEventListener('click', closeMenu)
    responsiveMenu.addEventListener('click', handleMenuClick)

    return () => {
      trigger.removeEventListener('click', openMenu)
      overlay.removeEventListener('click', closeMenu)
      responsiveMenu.removeEventListener('click', handleMenuClick)
      closeMenu()
      responsiveMenu.remove()
      overlay.remove()
    }
  }, [i18n.language])

  return (
    <div className="site-header-main-center d-flex justify-content-center align-items-center">
      <div className="main-menu-wrapper">
        {/* 
        HAMBURGER MENU
        */}
        <div id="zn-res-menuwrapper">
          <NavLink to="#" className="zn-res-trigger"></NavLink>
        </div>


        <div id="main-menu" className="main-nav zn_mega_wrapper">
          <ul id="menu-main-menu" className="main-menu zn_mega_menu">
            <li className="menu-item-mega-parent1">
              <NavLink exact activeClassName="active" to="" className="zn_mega_title">
                {t('page.programs')}
              </NavLink>
              <ul className="sub-menu clearfix">
                <li>
                  <NavLink to={t('url.gracie-combatives')}>
                    Gracie Combatives<sup>®</sup> <br />
                    <strong>{t('page.beginers')}</strong>
                  </NavLink>
                </li>
                <li>
                  <NavLink to={t('url.gracie-bullyproof')}>
                    Gracie Bullyproof<sup>®</sup> <br />
                    <strong>{t('page.kids')}</strong>
                  </NavLink>
                </li>
                <li>
                  <NavLink to={t('url.gracie-master-cycle')}>
                    Master Cycle<sup>®</sup> <br />
                    <strong>{t('page.advanced')}</strong>
                  </NavLink>
                </li>
                <li>
                  <NavLink to={t('url.gracie-women-empowered')}>
                    Women Empowered<sup>®</sup> <br />
                    <strong>{t('page.womenempowered')}</strong>
                  </NavLink>
                </li>
                <li>
                  <NavLink to={t('url.private-class')}>
                    <strong>{t('page.private-class')}</strong>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* <li className="menu-item-mega-parent"><NavLink exact activeClassName="active" to="/letny-tabor">Detský letný tábor</NavLink></li> */}
            {/* <li className="menu-item-mega-parent"><NavLink exact activeClassName="active" to="/101seminar">101 Seminár sebaobrany</NavLink></li> */}
            <li className="menu-item-mega-parent">
              <NavLink exact activeClassName="active" to={t('url.faq')}>
                Top 10 {t('page.question')}
              </NavLink>
            </li>
            <li className="menu-item-mega-parent">
              <NavLink exact activeClassName="active" to="/harmonogram">
                Harmonogram
              </NavLink>
            </li>
            <li className="menu-item-mega-parent">
              <NavLink exact activeClassName="active" to="/prihlaska">
                Prihláška
              </NavLink>
            </li>
            <li className="menu-item-mega-parent">
              <NavLink exact activeClassName="active" to="/kontakt">
                {t('page.contact')}
              </NavLink>
            </li>
            {/* <li className="menu-item-mega-parent">
              <NavLink exact activeClassName="active" to="/vase-2-percenta-pomozu">
                Vaše 2% pomôžu
              </NavLink>
            </li> */}
            {/* <li className="menu-item-mega-parent"><NavLink exact activeClassName="active" to="/eshop">eshop</NavLink></li> */}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default MainMenu

// <div className="app-menu navbar-menu">
// <div className="navbar-brand-box">
//     <a href="index.html" className="logo logo-dark">
//     <span className="logo-sm">
//         <img src="assets/images/logo-sm.png"  height={22} />
//     </span>
//     <span className="logo-lg">
//         <img src="assets/images/logo-dark.png"  height={17} />
//     </span>
//     </a>
//     <a href="index.html" className="logo logo-light">
//     <span className="logo-sm">
//         <img src="assets/images/logo-sm.png"  height={22} />
//     </span>
//     <span className="logo-lg">
//         <img src="assets/images/logo-light.png"  height={17} />
//     </span>
//     </a>
//     <button type="button" className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover">
//     <i className="ri-record-circle-line" />
//     </button>
// </div>

// <div id="scrollbar">
//     <div className="container-fluid">
//     <div id="two-column-menu">
//     </div>
//     <ul className="navbar-nav" id="navbar-nav">
//         <li className="menu-title"><span data-key="t-menu">Menu</span></li>

//         <li className="nav-item">
//         <a href="#" className="zn_mega_title" className="nav-NavLink" to="/">
//             <i className="ri-dashboard-2-line" /> <span data-key="t-dashboards">Training session</span>
//         </a>
//         </li>
//         <li className="nav-item">
//         <a href="#" className="zn_mega_title" className="nav-NavLink" to="/user-profile">
//             <i className="ri-apps-2-line" /> User profile
//         </a>
//         </li>

//         <li className="nav-item">
//         <a className="nav-NavLink menu-NavLink" href="/#" onClick={() => UserService.doLogout()} role="button" aria-expanded="false" aria-controls="sidebarLayouts">
//             <i className="ri-layout-3-line" /> <span data-key="t-layouts">Logout</span>
//         </a>
//         </li>

//     </ul>
//     </div>
// </div>
// <div className="sidebar-background" />
// </div>
